import { observer } from 'mobx-react';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { inject } from '../../common/container/inject';
import {
  IMainLayoutDomainStore,
  MainLayoutDomainStoreToken,
} from '../../view/layout/main/store/domain/IMainLayoutDomainStore';
import { ApplicationRoutes } from '../constants/routes';

export const RedirectGuard = observer((props: PropsWithChildren<{}>) => {
  const location = useLocation();
  const layoutDomainStore: IMainLayoutDomainStore = inject(MainLayoutDomainStoreToken);

  useEffect(() => {
    if(!layoutDomainStore?.ui?.activeUser?.entity) {
      layoutDomainStore.loadLayoutData();
    }
  }, [layoutDomainStore]);

  const isForcePage = location.pathname === ApplicationRoutes.ForcePasswordChange;
  const mustChangePassword = layoutDomainStore?.ui?.activeUser?.entity?.directives?.mustChangePassword;

  if (mustChangePassword && !isForcePage) {
    const from = location.pathname + location.search;
    return <Redirect to={`${ApplicationRoutes.ForcePasswordChange}?from=${encodeURIComponent(from)}`} />;
  }

  if (!mustChangePassword && isForcePage) {
    return <Redirect to={ApplicationRoutes.Root} />;
  }

  return <>{props.children}</>;
});
